{
  "about": "Every built-in cdbOS app (cdb_webos#1647). src/data/apps.ts, the BFF's access rule (backend/app/services/app_manifest.py) and the migrate job (run_migrations.py syncs it into public.available_apps) all read this file. kind: system = everyone has it, admin = Cortex, assignable = granted per role. dbName: the available_apps name where it differs from the id. aliases: old ids that open this app (deep links, saved windows) and stay reserved names. record false: no available_apps row (the shell gates it itself). displayName and knowledgeAreaAware seed a new row only; Cortex owns them afterwards.",
  "apps": [
    { "id": "app-store", "kind": "system", "category": "system", "displayName": "App Store" },
    { "id": "settings", "kind": "system", "category": "system", "displayName": "Einstellungen" },
    {
      "id": "widget-settings", "kind": "system", "category": "system", "displayName": "Widget Manager",
      "record": false, "hideFromMenu": true, "hideFromStore": true
    },
    { "id": "cortex", "dbName": "admin", "kind": "admin", "category": "admin", "displayName": "Cortex", "aliases": ["admin"] },
    {
      "id": "communicator2", "kind": "system", "category": "productivity", "displayName": "cdbChat",
      "knowledgeAreaAware": true
    },
    {
      "id": "collabora-editor", "kind": "system", "category": "productivity", "displayName": "Dokument-Editor",
      "record": false, "hideFromMenu": true, "hideFromStore": true,
      "note": "The popped-out Collabora editor from the Communicator split view (#227); opened for a file, never from the menu."
    },
    {
      "id": "ai-knowledge-extractor", "kind": "assignable", "category": "productivity",
      "displayName": "CDB Knowledge Extractor", "knowledgeAreaAware": true,
      "aliases": ["cdb-audio-recorder"], "note": "The Audio Recorder went into the Knowledge Extractor (#1584)."
    },
    {
      "id": "knowledge-verifier", "kind": "assignable", "category": "productivity",
      "displayName": "CDB Knowledge Verifier", "knowledgeAreaAware": true,
      "aliases": ["knowledge-browser"],
      "note": "The Knowledge Browser went into the Verifier (#1674): each area is granted for reading or verifying (can_verify)."
    },
    {
      "id": "cdb-sessions", "kind": "assignable", "category": "productivity", "displayName": "CDB Sessions",
      "knowledgeAreaAware": true
    },
    { "id": "cdb-training", "kind": "assignable", "category": "productivity", "displayName": "CDB Training Hub" },
    {
      "id": "prompt-library", "kind": "system", "category": "productivity", "displayName": "Prompts",
      "record": false, "hideFromMenu": true, "hideFromStore": true,
      "note": "No app any more (#1827): the Prompts widget and its panel. Old links, saved windows and prompt_shared notifications still name this id and open the panel."
    },
    {
      "id": "file-preview", "kind": "system", "category": "productivity", "displayName": "Dateivorschau",
      "hideFromMenu": true, "hideFromStore": true, "aliases": ["pdf-viewer", "multimedia"],
      "note": "The one preview window (#1648): everyone has it, it opens only with a file (openFile)."
    },
    {
      "id": "wissenshaus", "kind": "assignable", "category": "productivity", "displayName": "Wissenshaus",
      "note": "Granted per role like any other app (#1596); the TQS limits the content to the user's organisation."
    },
    {
      "id": "harness", "kind": "assignable", "category": "productivity", "displayName": "cdbHARNESS",
      "adminOnly": true,
      "note": "cdbHARNESS prototype v0 (#1366): agent roles propose, a human approves. Admins only until the usefulness test is done."
    },
    {
      "id": "cdb-control", "kind": "assignable", "category": "productivity", "displayName": "cdbControl",
      "adminOnly": true,
      "note": "cdbControl phase 1 (#1689): the client's tasks from recordings and by hand. Admins only until personal tasks and departments arrive."
    },
    {
      "id": "drive2", "kind": "system", "category": "system", "displayName": "cdbDrive",
      "knowledgeAreaAware": true
    }
  ]
}
